export default {
	title: 'Odeslání kopie e-mailem',
};
